angular.module("bm.indirect.tax.templates", ["indirect-tax/taxgroup/taxgroup-detail.2js.html", "indirect-tax/taxrate/taxrate-detail.2js.html"]);

angular.module("indirect-tax/taxgroup/taxgroup-detail.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("indirect-tax/taxgroup/taxgroup-detail.2js.html",
    "<div class=\"container-fluid no-left-padding view-container\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <h3 data-ng-show=\"vm.detail.isLoadingData()\">{{vm.detail.busyText}}</h3>\n" +
    "            <form id=\"taxgroupForm\" name=\"taxgroupForm\" data-ng-hide=\"vm.detail.isLoadingData()\" ng-init=\"vm.focusEvent()\">\n" +
    "                <bmp-page-header ng-class=\"{loading: vm.detailContext.detail.isLoadingData()}\" ng-hide=\"vm.isOnIframe\" data-bmp-bootstrap-affix=\"\">\n" +
    "                    <bmp-page-header-left-content>\n" +
    "                        <h1\n" +
    "                        uib-tooltip=\"{{vm.taxgroupLabel()}}\"\n" +
    "                        tooltip-trigger=\"mouseenter\"\n" +
    "                        tooltip-placement=\"bottom\" class=\"bmp-page-header-truncate\">{{vm.taxgroupLabel()}}</h1>\n" +
    "                    </bmp-page-header-left-content>\n" +
    "                    <bmp-page-header-right-content>\n" +
    "                        <button type=\"button\" data-fef-tab-stop=\"false\" id=\"taxgroupForm.save\"\n" +
    "                                class=\"btn btn-primary\"\n" +
    "                                data-qe-id=\"bm-taxgroupForm-save\"\n" +
    "                                data-ng-click=\"vm.detail.save();\"\n" +
    "                                data-translate=\"Bluemoon.IndirectTax.Common.Actions.Save\"></button>\n" +
    "                        <button type=\"button\" id=\"taxgroupForm.cancel\"\n" +
    "                                class=\"btn btn-default\"\n" +
    "                                data-qe-id=\"bm-taxgroupForm-cancel\"\n" +
    "                                data-ng-click=\"vm.detail.cancel()\"\n" +
    "                                data-translate=\"Bluemoon.IndirectTax.Common.Actions.Cancel\"></button>\n" +
    "                    </bmp-page-header-right-content>\n" +
    "                </bmp-page-header>\n" +
    "                <!--Name-->\n" +
    "                <div class=\"row\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                         data-bmp-control-group-field-id=\"name\"\n" +
    "                         data-bmp-control-group-label=\"{{'Bluemoon.IndirectTax.TaxGroup.Name' | translate | bmRequiredMark}}\"\n" +
    "                         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'name')\"\n" +
    "                         class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                        <input autocomplete=\"off\" type=\"text\"\n" +
    "                               id=\"name\"\n" +
    "                               name=\"name\"\n" +
    "                               data-qe-id=\"bm-taxgrouporm-name\"\n" +
    "                               class=\"form-control\"\n" +
    "                               data-ng-disabled=\"vm.data.systemId\"\n" +
    "                               data-ng-required=\"true\"\n" +
    "                               data-ng-model=\"vm.data.name\"\n" +
    "                               data-ng-model-options=\"vm.detail.defaultAsyncValidationNgModelOptions\"\n" +
    "                               data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'name')\"\n" +
    "                               data-bmp-entity-code=\"\"\n" +
    "                               data-bmp-entity-code-id=\"vm.id\"\n" +
    "                               data-bmp-entity-code-type=\"taxgroups\"\n" +
    "                               provider=\"vm.entityCodeValidator\"\n" +
    "                               data-fef-maxlength=\"250\"\n" +
    "                               ng-keydown=\"vm.changeFocus($event)\" />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <!--Effective Tax rate-->\n" +
    "                <div class=\"row\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                         data-bmp-control-group-field-id=\"taxGroupEffectiveRate\"\n" +
    "                         data-bmp-control-group-label=\"{{'Bluemoon.IndirectTax.TaxGroup.EffectiveTaxRate' | translate }}\"\n" +
    "                         label=\"{{'Bluemoon.IndirectTax.TaxGroup.EffectiveTaxRate' | translate  }}\"\n" +
    "                         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'rate')\"\n" +
    "                         class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                        <input type=\"text\" ng-disabled=\"true\"\n" +
    "                               id=\"taxGroupEffectiveRate\"\n" +
    "                               name=\"taxGroupEffectiveRate\"\n" +
    "                               class=\"form-control\"\n" +
    "                               data-qe-id=\"bm-taxgrouporm-effectivetaxrate\"\n" +
    "                               data-ng-model=\"vm.rate\"\n" +
    "                               data-ng-change=\"vm.detail.clearErrorFor(vm.rate, 'rate')\" />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <!--Tax Rate List-->\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-md-8\">\n" +
    "                        <bmp-toolbar toolbar-buttons=\"vm.toolbarButtons\"\n" +
    "                                     on-search=\"vm.onSearch($searchTerm)\"\n" +
    "                                     search-clicked=\"vm.onSearchClicked()\"\n" +
    "                                     search-focus-event-name=\"'bmpSearchInputFocus'\"\n" +
    "                                     has-column-picker=\"false\">\n" +
    "                        </bmp-toolbar>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-md-8\">\n" +
    "                        <wj-flex-grid style=\"max-height:300px\" control=\"vm.flexGrid\"\n" +
    "                                      class=\"bento-flex-grid\"\n" +
    "                                      allow-add-new=\"true\"\n" +
    "                                      allow-delete=\"true\"\n" +
    "                                      allow-sorting=\"SingleColumn\"\n" +
    "                                      items-source=\"vm.taxRateDetails\"\n" +
    "                                      selection-mode=\"Cell\"\n" +
    "                                      headers-visibility=\"Column\"\n" +
    "                                      is-read-only=\"false\"\n" +
    "                                      initialized=\"vm.gridInitialized(s,e)\"\n" +
    "                                      items-source-changed=\"vm.gridItemsSourceChanged(s,e)\"\n" +
    "                                      selection-changed=\"vm.gridSelectionChanged(s,e)\"\n" +
    "                                      cell-edit-ended=\"vm.gridCellEditEnded(s,e)\"\n" +
    "                                      item-formatter=\"vm.itemFormatter\"\n" +
    "                                      row-added=\"vm.rowAddedEvent(s,e)\"\n" +
    "                                      format-item=\"vm.formatItem(s,e)\">\n" +
    "                            <!-- BEGIN: NEW BENTO SELECTOR -->\n" +
    "                            <wj-flex-grid-column header=\"\" width=\"40\" min-width=\"40\" binding=\"$selected\" allow-sorting=\"false\" allow-dragging=\"false\" allow-resizing=\"false\" is-read-only=\"true\" css-class=\"col-select\" align=\"center\">\n" +
    "                                <wj-flex-grid-cell-template cell-type=\"ColumnHeader\">\n" +
    "                                    <div class=\"col-select\">\n" +
    "                                        <i class=\"bento-flex-grid-checkbox\"\n" +
    "                                           ng-click=\"$selector.onHeaderCheckBoxChange()\"\n" +
    "                                           ng-class=\"{'bento-icon-checkmark':$selector.headerCheckBoxMode === $selector.CHECKBOX_SELECTED,'bento-icon-minus-plain':$selector.headerCheckBoxMode === $selector.CHECKBOX_INDETERMINATE}\">\n" +
    "                                        </i>\n" +
    "                                    </div>\n" +
    "                                </wj-flex-grid-cell-template>\n" +
    "                                <wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "                                    <i class=\"bento-flex-grid-checkbox\"\n" +
    "                                       ng-click=\"$item.$selected = !$item.$selected;$selector.onCheckBoxChange();\"\n" +
    "                                       ng-class=\"{'bento-icon-checkmark':$item.$selected}\">\n" +
    "                                    </i>\n" +
    "                                </wj-flex-grid-cell-template>\n" +
    "                            </wj-flex-grid-column>\n" +
    "                            <!-- END: NEW BENTO SELECTOR -->\n" +
    "\n" +
    "\n" +
    "                            <wj-flex-grid-column header=\"{{'Bluemoon.IndirectTax.TaxRate.Name' | translate }}\"\n" +
    "                                                 binding=\"taxRateDetails\"\n" +
    "                                                 sort-member-path=\"taxRateDetails.code\"\n" +
    "                                                 data-type=\"Object\"\n" +
    "                                                 width=\"*\">\n" +
    "                                <wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "                                    {{$item.taxRateDetails.code}}\n" +
    "                                </wj-flex-grid-cell-template>\n" +
    "                                <wj-flex-grid-cell-template cell-type=\"CellEdit\">\n" +
    "                                    <bmp-select-combo list=\"taxRateList\"\n" +
    "                                                      name=\"taxRateDetails\"\n" +
    "                                                      flexgrid-control=\"vm.flexGrid\"\n" +
    "                                                      ng-model=\"$value\"\n" +
    "                                                      append-to-parent=\".modal-dialog\"\n" +
    "                                                      provider=\"vm.taxGroupSelectCombo\"\n" +
    "                                                      custom-template=\"true\"\n" +
    "                                                      on-change=vm.chnagevalue()>\n" +
    "                                    </bmp-select-combo>\n" +
    "                                </wj-flex-grid-cell-template>\n" +
    "                            </wj-flex-grid-column>\n" +
    "                            <wj-flex-grid-column header=\"{{'Bluemoon.IndirectTax.TaxRate.Rate' | translate }}\"\n" +
    "                                                 binding=\"taxRateDetails\"\n" +
    "                                                 sort-member-path=\"taxRateDetails.name\"\n" +
    "                                                 data-type=\"Object\"\n" +
    "                                                 is-read-only=\"true\"\n" +
    "                                                 width=\"*\">\n" +
    "                                <wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "                                    {{$item.taxRateDetails.name}}\n" +
    "                                </wj-flex-grid-cell-template>\n" +
    "                            </wj-flex-grid-column>\n" +
    "                            <wj-flex-grid-column header=\"{{'Bluemoon.IndirectTax.TaxRate.GeneralLedgerAccount' | translate }}\"\n" +
    "                                                 binding=\"taxRateDetails\"\n" +
    "                                                 sort-member-path=\"taxRateDetails.generalLedgerAccount\"\n" +
    "                                                 data-type=\"Object\"\n" +
    "                                                 is-read-only=\"true\"\n" +
    "                                                 width=\"*\">\n" +
    "                                <wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "                                    {{$item.taxRateDetails.generalLedgerAccount}}\n" +
    "                                </wj-flex-grid-cell-template>\n" +
    "                            </wj-flex-grid-column>\n" +
    "                        </wj-flex-grid>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </form>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("indirect-tax/taxrate/taxrate-detail.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("indirect-tax/taxrate/taxrate-detail.2js.html",
    "<div class=\"container-fluid no-left-padding view-container\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <h3 data-ng-show=\"vm.detail.isLoadingData()\">{{vm.detail.busyText}}</h3>\n" +
    "            <form id=\"taxrateForm\" name=\"taxrateForm\" data-ng-hide=\"vm.detail.isLoadingData()\">\n" +
    "                <bmp-page-header ng-class=\"{loading: vm.detailContext.detail.isLoadingData()}\" ng-hide=\"vm.isOnIframe\" data-bmp-bootstrap-affix=\"\">\n" +
    "                    <bmp-page-header-left-content>\n" +
    "                        <h1\n" +
    "                          uib-tooltip=\"{{vm.taxrateLabel()}}\"\n" +
    "                          tooltip-trigger=\"mouseenter\"\n" +
    "                          tooltip-placement=\"bottom\" class=\"bmp-page-header-truncate\">{{vm.taxrateLabel()}}</h1>\n" +
    "                    </bmp-page-header-left-content>\n" +
    "                    <bmp-page-header-right-content>\n" +
    "                        <button type=\"button\" data-fef-tab-stop=\"false\" id=\"taxrateForm.save\"\n" +
    "                                data-qe-id=\"bm-taxrateForm-save\"\n" +
    "                                class=\"btn btn-primary\"\n" +
    "                                data-ng-click=\"vm.detail.save();\"\n" +
    "                                data-translate=\"Bluemoon.IndirectTax.Common.Actions.Save\"></button>\n" +
    "                        <button type=\"button\" id=\"taxrateForm.cancel\"\n" +
    "                                data-qe-id=\"bm-taxrateForm-cancel\"\n" +
    "                                class=\"btn btn-default\"\n" +
    "                                data-ng-click=\"vm.detail.cancel()\"\n" +
    "                                data-translate=\"Bluemoon.IndirectTax.Common.Actions.Cancel\"></button>\n" +
    "                    </bmp-page-header-right-content>\n" +
    "                </bmp-page-header>\n" +
    "                <!--Name-->\n" +
    "                <div class=\"row\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                         data-bmp-control-group-field-id=\"name\"\n" +
    "                         data-bmp-control-group-label=\"{{'Bluemoon.IndirectTax.TaxRate.Name' | translate | bmRequiredMark}}\"\n" +
    "                         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'name')\"\n" +
    "                         class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                        <input autocomplete=\"off\" type=\"text\"\n" +
    "                               id=\"name\"\n" +
    "                               name=\"name\"\n" +
    "                               data-qe-id=\"bm-taxrateForm-name\"\n" +
    "                               class=\"form-control\"\n" +
    "                               data-ng-disabled=\"vm.data.systemId\"\n" +
    "                               data-ng-required=\"true\"\n" +
    "                               data-ng-model=\"vm.data.name\"\n" +
    "                               data-ng-model-options=\"vm.detail.defaultAsyncValidationNgModelOptions\"\n" +
    "                               data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'name')\"\n" +
    "                               data-bmp-entity-code=\"\"\n" +
    "                               data-bmp-entity-code-id=\"vm.id\"\n" +
    "                               data-bmp-entity-code-type=\"taxitems\"\n" +
    "                               provider=\"vm.entityCodeValidator\"\n" +
    "                               data-setup-focus-on-link=\"\"\n" +
    "                               data-fef-maxlength=\"250\" />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <!--Rate-->\n" +
    "                <div class=\"row\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                         data-bmp-control-group-field-id=\"taxRates\"\n" +
    "                         data-bmp-control-group-label=\"{{'Bluemoon.IndirectTax.TaxRate.Rate' | translate | bmRequiredMark}}\"\n" +
    "                         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'taxRates')\"\n" +
    "                         class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                        <input autocomplete=\"off\" type=\"text\"\n" +
    "                               id=\"taxRates\"\n" +
    "                               name=\"taxRates\"\n" +
    "                               data-qe-id=\"bm-taxrateForm-taxRates\"\n" +
    "                               class=\"form-control\"\n" +
    "                               data-ng-required=\"true\"\n" +
    "                               data-ng-model=\"vm.data.taxRates[0].rate\"\n" +
    "                               data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'taxRates')\"\n" +
    "                               data-ng-blur=\"vm.updateRateFormate(vm.data.taxRates[0].rate)\"\n" +
    "                               data-bmp-big-number=\"'n4'\"\n" +
    "                               bm-format-on-blur=\"\"\n" +
    "                               data-bmp-big-number-range-validator\n" +
    "                               min=\"0.0000\"\n" +
    "                               max=\"100.0000\"\n" +
    "                               data-bmp-control-group-field=\"Bluemoon.IndirectTax.TaxRate.Rate\" />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <!-- GL Account -->\n" +
    "                <div class=\"row\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                         data-bmp-control-group-field-id=\"generalLedgerAccount\"\n" +
    "                         data-bmp-control-group-label=\"{{'Bluemoon.IndirectTax.TaxRate.GeneralLedgerAccount' | translate }}\"\n" +
    "                         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'generalLedgerAccount')\"\n" +
    "                         class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                        <input autocomplete=\"off\" type=\"text\"\n" +
    "                               id=\"generalLedgerAccount\"\n" +
    "                               name=\"generalLedgerAccount\"\n" +
    "                               data-qe-id=\"bm-taxrateForm-GLaccount\"\n" +
    "                               class=\"form-control\"\n" +
    "                               data-ng-model=\"vm.data.generalLedgerAccount\"\n" +
    "                               data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'generalLedgerAccount')\"\n" +
    "                               data-fef-maxlength=\"60\" />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </form>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);
